export default __webpack_public_path__ + "static/media/F.bd5741db.svg";